import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import ActivityRow from './ActivityRow';
import { jsx as _jsx } from "react/jsx-runtime";
const IconColumn = styled.div.withConfig({
  displayName: "TimelineBlock__IconColumn"
})(["align-self:stretch;display:flex;flex-direction:column;align-items:center;&::before{content:' ';flex:1 0 auto;display:inline-block;position:relative;margin-block-start:", ";margin-block-end:", ";", "}&::after{content:' ';flex:1 0 auto;display:inline-block;position:relative;margin-block-start:", ";margin-block-end:", ";", "}"], ({
  theme
}) => `-${theme.space['400']}`, ({
  theme
}) => theme.space['200'], ({
  $isFirst,
  theme
}) => !$isFirst && `border-left: ${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']};`, ({
  theme
}) => theme.space['200'], ({
  theme
}) => `-${theme.space['400']}`, ({
  $isLast,
  theme
}) => !$isLast && `border-left: ${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']};`);
const TimelineBlock = ({
  block,
  message,
  callbacks,
  sectionId
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "400",
    children: block.activities.map((activity, index) => {
      const isFirst = index === 0;
      const isLast = index === block.activities.length - 1;
      return /*#__PURE__*/_jsx(ActivityRow, {
        activity: activity,
        message: message,
        callbacks: callbacks,
        sectionId: sectionId,
        iconWrapper: icon => /*#__PURE__*/_jsx(IconColumn, {
          $isFirst: isFirst,
          $isLast: isLast,
          children: icon
        })
      }, index);
    })
  });
};
export default TimelineBlock;